import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader2, Trophy } from 'lucide-react';
import { API } from '../../utils/apiConfig';
import { trackConversion } from '../../utils/analytics';

export default function EventPaymentStatusPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get('order_id');
  const done = params.get('done');
  const [status, setStatus] = useState(done ? 'success' : 'checking');
  const [regNo, setRegNo] = useState('');

  useEffect(() => {
    if (done) {
      trackConversion('registration');
      trackConversion('payment');
      return;
    }
    if (!orderId) return;
    let tries = 0;
    const check = async () => {
      try {
        const res = await axios.post(`${API}/events/payments/verify`, { order_id: orderId });
        if (res.data.verified) {
          setStatus('success');
          setRegNo(res.data.registration_number || '');
          trackConversion('registration');
          trackConversion('payment');
          return;
        }
      } catch (e) { /* ignore */ }
      tries += 1;
      if (tries < 5) setTimeout(check, 2500);
      else setStatus('pending');
    };
    check();
  }, [orderId, done]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 to-fuchsia-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-xl p-8 text-center" data-testid="event-payment-status">
        {status === 'checking' && (<><Loader2 className="w-14 h-14 text-violet-500 animate-spin mx-auto mb-4" /><h1 className="text-lg font-bold text-slate-800">Confirming your payment…</h1><p className="text-sm text-slate-500 mt-1">Please wait, do not close this page.</p></>)}
        {status === 'success' && (<>
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center mx-auto mb-4 shadow-lg"><CheckCircle className="w-11 h-11 text-white" /></div>
          <h1 className="text-xl font-bold text-emerald-600" data-testid="event-payment-success">Registration Confirmed!</h1>
          {regNo && <p className="text-sm text-slate-500 mt-1">Reg No: <span className="font-mono font-semibold">{regNo}</span></p>}
          <p className="text-sm text-slate-500 mt-1">You'll receive a WhatsApp confirmation shortly.</p>
        </>)}
        {status === 'pending' && (<><Trophy className="w-14 h-14 text-amber-500 mx-auto mb-4" /><h1 className="text-lg font-bold text-amber-600">Payment Processing</h1><p className="text-sm text-slate-500 mt-1">If money was deducted, your registration will confirm automatically. Check "My Registrations" shortly.</p></>)}
        <button onClick={() => navigate('/events')} className="mt-6 w-full h-11 rounded-xl bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white font-semibold" data-testid="back-to-events-btn">Back to Events</button>
      </div>
    </div>
  );
}
